'use strict';
var ProfessinalInfoController = /** @class */ (function () {
    /*@ngInject*/
    function ProfessinalInfoController(Auth, $state, $scope, $mdToast, Util, GeneralInfoService, ProfessionalInfoService, SettingsService) {
        this.defaultCountry = 'US';
        this.searchText = null;
        this.enteredRegion = null;
        this.postalCodePattern = "";
        this.phonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.maxPhoneLength = 12;
        this.faxPattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.phonePlaceholder = 'xxx-xxx-xxxx';
        this.maxFaxLength = 12;
        this.countryChangedEvents = [];
        this.usPhonePattern = new RegExp('^([2-9]{1})(\\d{2})([\\s-./]?)(\\d{3})([\\s-./]?)(\\d{4})$');
        this.usPhonePlaceholder = 'xxx-xxx-xxxx';
        this.intlPhonePattern = new RegExp('^(\\d)(?!\\1+$)\\d{9,13}$');
        this.intlPhonePlaceholder = '';
        this.billingAddress = {};
        this.user = {};
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.showAlert = false;
        this.generalInfo = GeneralInfoService;
        this.pinfoService = ProfessionalInfoService;
        this.settingsService = SettingsService;
        this.$scope = $scope;
        this.$mdToast = $mdToast;
        this.Util = Util;
        var self = this;
        if (self.mode == 'new') {
            self.createForm = true;
            self.updateForm = false;
            self.pinfo = {};
            self.pinfo.country = {
                countryCode: 'US',
                countryName: 'United States of America',
                postalCodeRegex: '^(\\d{9})$',
                regionCodeRequired: true
            };
        }
        else {
            self.createForm = false;
            self.updateForm = true;
            if (self.pinfo) {
                self.billingAddress = self.pinfo.billingAddress;
                if (self.pinfo.billingAddress.countryCode == 'US') {
                    self.phonePattern = self.usPhonePattern;
                    self.maxPhoneLength = 12;
                    self.faxPattern = self.usPhonePattern;
                    self.maxFaxLength = 12;
                    self.phonePlaceholder = self.usPhonePlaceholder;
                }
                else {
                    self.phonePattern = self.intlPhonePattern;
                    self.maxPhoneLength = 14;
                    self.faxPattern = self.intlPhonePattern;
                    self.maxFaxLength = 14;
                    self.phonePlaceholder = self.intlPhonePlaceholder;
                }
            }
        }
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.onUpdate({
                $event: {
                    pinfo: self.pinfo
                }
            });
        });
        $scope.$on('countryUpdated', function (event, data) {
            if (data.countryCode == 'US') {
                self.phonePattern = self.usPhonePattern;
                self.maxPhoneLength = 12;
                self.faxPattern = self.usPhonePattern;
                self.maxFaxLength = 12;
                self.phonePlaceholder = self.usPhonePlaceholder;
            }
            else {
                self.phonePattern = self.intlPhonePattern;
                self.maxPhoneLength = 14;
                self.faxPattern = self.intlPhonePattern;
                self.maxFaxLength = 14;
                self.phonePlaceholder = self.intlPhonePattern;
            }
            self.countryChangedEvents.push('phone');
            self.countryChangedEvents.push('fax');
        });
    }
    ProfessinalInfoController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#prof-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    ProfessinalInfoController.prototype.updateChange = function (fieldName, newVal, field, displayName) {
        var self = this;
        self.settingsService.isFormPristine = field.$pristine;
        if (this.countryChangedEvents.length) {
            this.countryChangedEvents.pop();
            return;
        }
        self.settingsService.isPinfoFormValid = field.$valid;
        if (field.$valid) {
            this.user['email'] = this.settingsService.pinfoUser.email;
            this.user[fieldName] = newVal;
            if (self.changeAccountInfo) {
                this.settingsService.pinfoUser = this.user;
                this.settingsService.pinfoCustomerId = this.pinfo.customerId;
            }
            else {
                this.pinfoService.updateAccount(this.pinfo.customerId, this.user).then(function (response) {
                    if (response.status != 200 || response.data.errors.length) {
                        self.Util.handleApiError(response, self);
                    }
                    else {
                        self.Util.resetApiError(self);
                        self.showSimpleToast(displayName + " Updated", '');
                    }
                });
            }
        }
    };
    ProfessinalInfoController.prototype.updatePhone = function (fieldName, businessPhone, formBusinessPhone, displayName, createForm, updateForm) {
        this.settingsService.isPinfoFormValid = this.pinfo.businessPhone;
        if (this.pinfo.businessPhone) {
            this.pinfo.businessPhone = this.pinfo.businessPhone.replace(/[\s-.\/]/g, "");
            if (updateForm) {
                this.updateChange(fieldName, this.pinfo.businessPhone, formBusinessPhone, displayName);
            }
        }
    };
    ProfessinalInfoController.prototype.updateFax = function (fieldName, fax, formFax, displayName) {
        if (this.pinfo.fax) {
            this.pinfo.fax = this.pinfo.fax.replace(/[\s-.\/]/g, "");
            console.log('Fax num -> ', this.pinfo.fax);
        }
        if (this.updateForm) {
            this.updateChange(fieldName, fax, formFax, displayName);
        }
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    ProfessinalInfoController.prototype.$onChanges = function (changes) {
        if (changes.pinfo) {
            this.pinfo = angular.copy(this.pinfo);
        }
    };
    ProfessinalInfoController.prototype.fireEvent = function (eventName) {
        this.$scope.$emit('professionalInfoTrackingEvent', { eventName: eventName });
    };
    ProfessinalInfoController.prototype.validateFormAndFireError = function (fieldName, errorName, exceptionProperties) {
        if (exceptionProperties === void 0) { exceptionProperties = []; }
        var field = this.professionalForm[fieldName];
        if (!field)
            return;
        for (var error in field.$error) {
            if (exceptionProperties.indexOf(error) === -1 && field.$error.hasOwnProperty(error) && field.$error[error]) {
                this.fireEvent(errorName);
                return;
            }
        }
    };
    return ProfessinalInfoController;
}());
export default ProfessinalInfoController;
//# sourceMappingURL=professional-info.controller.js.map